import React from 'react';
import { Button } from './button';
import Icon from './icon';

interface QuickAction {
  id: string;
  label: string;
  icon: string;
  action: string;
}

interface FunctionButtonsProps {
  isTyping: boolean;
  showQuickActions: boolean;
  showImageOptions: boolean;
  onVoiceRecord: () => void;
  onImageUpload: () => void;
  onQuickAction: (action: any) => void;
  onToggleQuickActions: () => void;
  onToggleImageOptions: () => void;
  onCloseMenus: () => void;
  quickActions: readonly QuickAction[];
}

export const ChatFunctionButtons: React.FC<FunctionButtonsProps> = ({
  isTyping,
  showQuickActions,
  showImageOptions,
  onVoiceRecord,
  onImageUpload,
  onQuickAction,
  onToggleQuickActions,
  onToggleImageOptions,
  onCloseMenus,
  quickActions
}) => {
  const handlePlusClick = () => {
    if (showImageOptions) {
      onToggleImageOptions();
      onToggleQuickActions();
    } else if (showQuickActions) {
      onToggleQuickActions();
    } else {
      onToggleQuickActions();
    }
  };

  return (
    <div className="flex items-center justify-center mt-3">
      {/* Rounded Container for Buttons */}
      <div className="bg-gray-100 dark:bg-gray-800 rounded-full p-1 flex items-center gap-1">
        {/* Voice Button */}
        <Button
          variant="ghost"
          size="sm"
          onClick={onVoiceRecord}
          className="flex items-center gap-2 px-3 py-2 rounded-full hover:bg-white dark:hover:bg-gray-700"
          disabled={isTyping}
        >
          <Icon name="mic" size={18} />
          Nói
        </Button>

        {/* Plus Button with Context Menu */}
        <div className="relative context-menu-container">
          <Button
            variant="ghost"
            size="sm"
            onClick={handlePlusClick}
            className={`flex items-center gap-2 px-3 py-2 rounded-full hover:bg-white dark:hover:bg-gray-700 ${
              showQuickActions || showImageOptions ? 'bg-white dark:bg-gray-700' : ''
            }`}
            disabled={isTyping}
          >
            <Icon name="plus" size={18} />
            Thêm
          </Button>

          {/* Context Menu */}
          {(showQuickActions || showImageOptions) && (
            <div className="absolute bottom-full left-0 mb-2 w-64 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50">
              <div className="p-2">
                {/* Image Options */}
                <div className="mb-2">
                  <div className="px-3 py-2 text-sm font-medium text-gray-500 dark:text-gray-400">
                    Gửi ảnh
                  </div>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => {
                      onImageUpload();
                      onCloseMenus();
                    }}
                    className="w-full justify-start text-left"
                    disabled={isTyping}
                  >
                    <Icon name="camera" size={18} className="mr-3" />
                    Chụp ảnh mới
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => {
                      onImageUpload();
                      onCloseMenus();
                    }}
                    className="w-full justify-start text-left"
                    disabled={isTyping}
                  >
                    <Icon name="image" size={18} className="mr-3" />
                    Chọn ảnh có sẵn
                  </Button>
                </div>

                {/* Quick Actions */}
                <div>
                  <div className="px-3 py-2 text-sm font-medium text-gray-500 dark:text-gray-400">
                    Thao tác nhanh
                  </div>
                  {quickActions.map((action) => (
                    <Button
                      key={action.id}
                      variant="ghost"
                      size="sm"
                      onClick={() => {
                        onQuickAction(action);
                        onCloseMenus();
                      }}
                      className="w-full justify-start text-left"
                      disabled={isTyping}
                    >
                      <Icon name={action.icon as any} size={18} className="mr-3" />
                      {action.label}
                    </Button>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
